const lastPathSegment = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.split('/').filter(Boolean).pop() || raw;
};

export const getAwsOperationScope = (operation = {}) => {
  const scopeType = String(operation.scope_type || operation.scopeType || 'regions').trim() || 'regions';
  const scope = lastPathSegment(operation.scope);
  return { scopeType, scope };
};

export const awsOperationPaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/operations`,
  detail: (connectionId, operation) => {
    const operationName = lastPathSegment(operation?.name);
    const { scopeType, scope } = getAwsOperationScope(operation);
    return `/compute/cloud-account-connections/${connectionId}/aws/operations/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(operationName)}`;
  },
};
